import React from 'react';

const PageLoader = () => (
  <div
    className="fixed inset-0 flex flex-col items-center justify-center bg-neutral-900/90 backdrop-blur-sm z-[9999]"
    role="status"
    aria-live="polite"
    aria-label="Loading page"
  >
    <div className="relative w-20 h-20" aria-hidden="true">
      <div className="absolute inset-0 rounded-full border-4 border-orange-500/20" />
      <div className="absolute inset-0 rounded-full border-4 border-t-orange-500 border-r-transparent animate-spin" />
    </div>
    <p className="mt-4 text-sm text-white/70">Loading…</p>
  </div>
);

export default PageLoader;
